<template>
  <v-combobox
    multiple
    v-model="comboText"
    append-icon
    chips
    deletable-chips
    class="tag-input"
    :search-input.sync="search"
    :hint="
      langEdition !== locale
        ? Array.isArray(answer[locale])
          ? answer[locale].join()
          : answer[locale]
        : null
    "
    :persistent-hint="showHint"
    @change="updateComboText"
    @keyup.tab="updateTags"
    @keyup.enter="updateTags"
    @paste="updateTags"
  >
    <language-translator
      v-if="locale !== langEdition"
      :langEdition="langEdition"
      :textToTranslate="answer[locale]"
      :type="'answerList'"
      @text-translated="updateTextInputTranslated"
      slot="append"
    >
    </language-translator>
  </v-combobox>
</template>

<script>
import LanguageTranslator from './LanguageTranslator.vue';

export default {
  name: 'TextTag',
  components: {
    LanguageTranslator,
  },
  props: {
    answer: {
      type: Object,
      default: null,
    },
    langEdition: {
      type: String,
      default: null,
    },
    showHint: {
      type: Boolean,
      default: null,
    },
  },
  data() {
    return {
      comboText: [],
      search: '',
    };
  },
  created() {
    this.comboText = this.answer[this.langEdition];
  },
  watch: {
    langEdition() {
      this.comboText = this.answer[this.langEdition];
    },
  },
  methods: {
    updateTextInputTranslated(textTranslated, type) {
      if (textTranslated) {
        if (type === 'answerList') {
          this.comboText = textTranslated;
        }
      }
    },
    updateTags() {
      console.log('updatags');
      this.$nextTick(() => {
        this.comboText.push(...this.search.split(','));
        this.$nextTick(() => {
          this.search = '';
        });
      });
    },
    updateComboText() {
      //this.updateTags()
      console.log('this.comboText', this.comboText);
      this.$emit('update-combo-text', this.comboText);
    },
  },
  computed: {
    locale() {
      return this.$i18n.locale;
    },
  },
};
</script>

<style lang="sass" scoped>

div.v-input
 width: 300px

.deleteIcon
  max-width: 20px;
  margin-left: 7px;
  margin-right: 10px;

.onlyCheckBox
  max-width: 20px
  margin-left: 5px
  margin-right: 10px
  margin-top: 0px

.checkBoxWithDelete
  max-width: 20px
  max-height: 24px
  margin-left: 5px
  margin-right: 10px
  margin-top: 0px

.surveyClass
  margin-right: 30px
  max-height: 66px
  justify: left

.surveyClassWithDelete
  margin-left: 35px
  max-height: 66px

.closeSurvey
  position: absolute

.mcqClass
  margin-top: 0px
  max-height: 66px

.imageClass
  margin-top: 0px
  max-height: 150px

.readOnlyClass
  pointer-events: none;

.showHintClass
  margin-bottom: 20px;
</style>
